<template>
  <Wrapper class="app app--auth">
    <div class="app-content">
      <div class="block block-shadow block-rounded py-30">
        <header class="block-header text-center" v-if="isDefaultLogo != ''">
          <img :src="isDefaultLogo" alt="brand logo" />
        </header>
        <div>
          <div
            v-if="isMainSocialLogin[0] && isMainSocialLogin[0].value.status"
            class="block-content p-0"
          >
            <h1 class="block-title text-center">Sign up with</h1>
          </div>
          <div v-if="authErrors.length" class="block-content">
            <div class="alert alert-danger">
              <div v-for="(error, index) in authErrors" :key="index">
                {{ error }}
              </div>
            </div>
          </div>
          <template
            v-if="isMainSocialLogin[0] && isMainSocialLogin[0].value.status"
          >
            <SocialAuth class="block-content text-center" returnTo="/" />
            <div class="block-content">
              <div class="sep sep--or">
                <span>OR</span>
              </div>
            </div>
          </template>
          <div class="block-content text-center">
            <router-link to="/register/form">
              Sign up using your email
            </router-link>
          </div>
          <div class="block-content text-center">
            Already have an account?
            <router-link to="/" class>Sign In</router-link>
          </div>
        </div>
        <!-- <Footer /> -->
      </div>
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from "./Wrapper";
// import Footer from "./Footer";
import SocialAuth from "./SocialAuth";
import _ from "lodash";

export default {
  components: {
    Wrapper,
    // Footer,
    SocialAuth
  },
  async mounted() {
    await this.$store.dispatch("fetchOptions");

    this.isMainSocialLogin = this.options.filter(
      option => option.key === "sociallogin.main"
    );

    let defaultLogoStatus = _.filter(this.options, ["key", "defaultlogo.main"]);
    if (
      defaultLogoStatus.length &&
      defaultLogoStatus[0].value.status == false
    ) {
      let defaultLogo = _.filter(this.options, ["key", "defaultlogo.sub"]);
      if (defaultLogo.length && defaultLogo[0].value.image) {
        this.isDefaultLogo = defaultLogo[0].value.image;
      } else {
        this.isDefaultLogo = this.headroomLogo;
      }
    } else {
      this.isDefaultLogo = this.headroomLogo;
    }
  },
  data() {
    return {
      authErrors: this.$store.state.auth.errors,
      isMainSocialLogin: false,
      isDefaultLogo: "",
      headroomLogo: require("@/assets/media/brand.svg")
    };
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  color: var(--primary, $brand-primary);
}
</style>
